var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIFaltaPessoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1D5187"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.25 31.8343C27.2507 30.026 26.8361 27.9525 27.0632 25.8989C27.2902 23.8453 28.1478 21.9125 29.5179 20.3661C30.8881 18.8197 32.7036 17.7357 34.7149 17.263C36.7262 16.7903 38.8345 16.9523 40.75 17.7265L34.5 24.4999L35.3844 28.6156L39.5 29.4999L46.2734 23.2499C47.0477 25.1655 47.2096 27.2738 46.7369 29.2851C46.2643 31.2964 45.1802 33.1119 43.6338 34.482C42.0874 35.8522 40.1546 36.7097 38.101 36.9368C36.0475 37.1638 33.974 36.7492 32.1656 35.7499L23.4062 45.9062C22.7018 46.6107 21.7463 47.0064 20.75 47.0064C19.7537 47.0064 18.7982 46.6107 18.0937 45.9062C17.3893 45.2017 16.9935 44.2462 16.9935 43.2499C16.9935 42.2537 17.3893 41.2982 18.0937 40.5937L28.25 31.8343Z",
    stroke: "#B5E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFaltaPessoal);
export default __webpack_public_path__ + "static/media/i-falta-pessoal.18f28d9ee33e4379bfdac6d2fcf1a2d8.svg";
export { ForwardRef as ReactComponent };